import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isBuildUp } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidSilkPrintMethod = (values: EstimateValues, silkPrintMethod?: string) => {
  switch (silkPrintMethod) {
    case ESTIMATE_CONSTANT.シルク印刷工法.お任せ.value:
      return true
    case ESTIMATE_CONSTANT.シルク印刷工法.写真法.value:
      return !isBuildUp(values)
    default:
      return false
  }
}

export default isValidSilkPrintMethod
